<template>
  <div class="koc-container">
    <head-page />
    <div class="koc-content">
      <div class="koc-main">
        <div class="koc-banner">
          <banner-swiper :brand="brand"></banner-swiper>
        </div>
        <form-page class="koc-form" ref="formPageRef" :brand="brand" :carList="carList" :btn="btn"></form-page>
      </div>
    </div>
    <footer-page></footer-page>
  </div>
</template>

<script>
import HeadPage from '@/components/HeadPage.vue'
import BannerSwiper from '@/components/BannerSwiper.vue'
import FormPage from '@/components/FormPage.vue'
import FooterPage from '@/components/FooterPage.vue'

export default {
  name: 'IcaurKOC',
  components: {
    HeadPage,
    BannerSwiper,
    FormPage,
    FooterPage,
  },
  data() {
    return {
      btn: { btnBg: '#f48e30', btnColor: '#111' },
      brand: {
        name: 'icaur',
        id: 246,
      },
      carList: [{ name: 'V23 (RWD)' }, { name: 'V23 (AWD)' }, { name: 'V27' }, { name: 'V9' }],
    }
  },
  mounted() {
    this.$nextTick(() => {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    })
  },
}
</script>

<style lang="scss" scoped>
.koc-container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.koc-content {
  flex: 1;
  padding-top: 60px;
}

.koc-main {
  display: flex;
  flex-direction: column;
  width: 100%;

  .koc-banner {
    width: 100%;
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .koc-form {
    width: 100%;
  }
}

@media (min-width: 768px) {
  .koc-main {
    flex-direction: row;
    align-items: center;

    .koc-banner {
      width: 50%;
    }

    .koc-form {
      width: 50%;
    }
  }
}
</style>
